module.exports = __webpack_public_path__ + "static/media/greenArrowRight.280ec2a2.svg";